"use client"; 

import { Eye, EyeOff, Lock } from "lucide-react";
import { useState } from "react";

interface PasswordFieldProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    name?: string;
    label?: string;
    error?: string;
}

export const PasswordField = ({ value, onChange, placeholder = "Password", name = "password", label, error }: PasswordFieldProps) => {
    const [isVisible, setIsVisible] = useState(false);
    return (
        <div className="space-y-1.5">
            {label && <label className="block text-sm font-medium text-stone-600">{label}</label>}
            <div className="relative">
                <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400 pointer-events-none" />
                <input 
                    type={isVisible ? "text" : "password"}
                    placeholder={placeholder}
                    name={name}
                    value={value}
                    onChange={onChange}
                    required
                    minLength={6}
                    className={`w-full p-3 pl-10 pr-10 rounded-md bg-stone-100 border focus:ring-2 transition-colors text-stone-900 placeholder:text-stone-400 ${
                        error ? 'border-red-400 focus:ring-red-400/50' : 'border-stone-300 focus:ring-amber-500/80'
                    }`}
                />
                <button type="button" onClick={() => setIsVisible(p => !p)} className="absolute top-1/2 right-3 -translate-y-1/2 text-stone-400 hover:text-stone-600 transition-colors">
                    {isVisible ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
            </div>
            {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>
    );
};
